<template>
  <div class="list-container">
    <BusinessList
      :showStateFilter="true"
      :showDefaultCommand="false"
      ref="BusinessListRef"
      v-show="!dialogFormVisible"
      :approvalParams="{
        modify: 1,
        changeStatus: 1
      }"
      businessTypeName="TABLE_APPROVAL_BUSINESS"
      :FilterFieldProps="FilterField"
    >
      <template v-slot:command="{ scope }">
        <el-link
          href="javascript:void(0);"
          class="mr-10"
          type="primary"
          @click="handleApproval(scope)"
        >
          审批修改
        </el-link>
      </template>
    </BusinessList>
    <div v-if="dialogFormVisible">
      <div style="display:flex;padding-top:20px">
        <FormComponent
          :id="activeId"
          :initFormData="initFormData"
          :fromFieldData="originFromFieldData"
          :dialogFormVisible="dialogFormVisible"
          :api="'business'"
          :isShowCloseBtn="false"
          :isShowSubmitBtn="false"
          :formDisabled="true"
        />
        <FormComponent
          :id="activeId"
          :initFormData="initFormData"
          :fromFieldData="targetFromFieldData"
          :dialogFormVisible="dialogFormVisible"
          :api="'business'"
          :isShowCloseBtn="false"
          :isShowSubmitBtn="false"
          :formDisabled="true"
        />
      </div>
      <div class="dialog-footer ml-20 mb-20">
        <el-button @click="dialogFormVisible = false" >
          {{ t("table.cancel") }}
        </el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="handleSubmit('approve')"
        >
          通过
        </el-button>
        <el-button
          type="danger"
          :loading="submitLoading"
          @click="handleSubmit('reject')"
        >
          拒绝
        </el-button>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs, ref } from 'vue'
import { ElMessageBox, ElMessage } from 'element-plus'
import BusinessList from '@/views/business/businessList/components/BusinessTable.vue'
import FormComponent from '@/components/Form/index.vue'
import { FromFieldData } from '@/views/business/businessList/FieldFrom'
import { cloneDeep } from 'lodash'
import { reviewApprove, reviewReject } from '@/apis/Dictionary'
import { getPageList as getUrlList } from '@/apis/Form'
import { getUserDetailByUserId } from '@/apis/user'
import { FilterField } from './FilterField'

import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'Appeovalbusinessedit',
  components: {
    BusinessList,
    FormComponent
  },
  setup() {
    const { t } = useI18n()
    const BusinessListRef = ref(null)
    const dataMap = reactive({
      activeId: 0,
      dialogFormVisible: false,
      submitLoading: false,
      initFormData: cloneDeep(FromFieldData),
      originFromFieldData: cloneDeep(FromFieldData),
      targetFromFieldData: cloneDeep(FromFieldData),
      FilterField,
      handleApproval({ row }: any) {
        // 处理接口拿到的数据
        dataMap.activeId = row.id
        dataMap.originFromFieldData = cloneDeep(dataMap.initFormData)
        getUrlList(`business/review/${row.id}`).then((res: any) => {
          const origin = res.origin
          dataMap.originFromFieldData.forEach((k: any) => {
            k.formList.forEach(async(field: any) => {
              field.value = origin[field.fieldKey] || field.value
              switch (field.fieldKey) {
                case 'customerContactIds': {
                  const result = await getUrlList(field.config.url, { companyId: origin.customerCompanyId })
                  field.option = result
                }
                  break
                case 'customerCompanyId': {
                  const result = await getUrlList('customerCompany/dropdown', {
                    ids: origin.customerCompanyId
                  })
                  field.option = result.map((item: any) => {
                    return {
                      ...item
                    }
                  })
                }
                  break
                case 'salesManId': {
                  const result = await getUserDetailByUserId(origin.salesManId)
                  field.option = [{
                    id: result.id,
                    name: result.name
                  }]
                }
                  break
              }
            })
          })

          const target = res.target
          dataMap.targetFromFieldData.forEach((k: any) => {
            k.formList.forEach(async(field: any) => {
              field.value = target[field.fieldKey] || field.value
              switch (field.fieldKey) {
                case 'customerContactIds': {
                  const result = await getUrlList(field.config.url, { companyId: target.customerCompanyId })
                  field.option = result
                }
                  break
                case 'customerCompanyId': {
                  const result = await getUrlList('customerCompany/dropdown', {
                    ids: target.customerCompanyId
                  })
                  field.option = result.map((item: any) => {
                    return {
                      ...item
                    }
                  })
                }
                  break
                case 'salesManId': {
                  const result = await getUserDetailByUserId(target.salesManId)
                  field.option = [{
                    id: result.id,
                    name: result.name
                  }]
                }
                  break
              }
            })
          })

          console.log(dataMap.originFromFieldData, '-----', dataMap.targetFromFieldData)
          dataMap.originFromFieldData[0].formList.forEach((item: any) => {
            dataMap.targetFromFieldData[0].formList.forEach((k: any) => {
              if (item.fieldKey === k.fieldKey) {
                const _originValue = item.value ? item.value.toString() : item.value
                const _targetValue = k.value ? k.value.toString() : k.value
                if (_originValue !== _targetValue) {
                  item.config.colorTheme = 1
                  k.config.colorTheme = 2
                }
              }
            })
          })
          dataMap.originFromFieldData[1].formList.forEach((item: any) => {
            dataMap.targetFromFieldData[1].formList.forEach((k: any) => {
              if (item.fieldKey === k.fieldKey) {
                const _originValue = item.value ? item.value.toString() : item.value
                const _targetValue = k.value ? k.value.toString() : k.value
                if (_originValue !== _targetValue) {
                  item.config.colorTheme = 1
                  k.config.colorTheme = 2
                }
              }
            })
          })
          dataMap.dialogFormVisible = true
        })
      },
      async handleSubmit(type: string) {
        try {
          if (type === 'reject') {
            ElMessageBox.prompt(
              '请输入原因：',
              '提交',
              {
                confirmButtonText: t('table.confirm'),
                cancelButtonText: t('table.cancel'),
                cancelButtonClass: 'el-button--danger'
              }
            ).then(async(params: any) => {
              const { value } = params
              await reviewReject('business', dataMap.activeId, { comment: value })
              ;(BusinessListRef.value as any).getList()
              dataMap.dialogFormVisible = false
              ElMessage.success('操作成功！')
            })
          } else if (type === 'approve') {
            await reviewApprove('business', dataMap.activeId)
            ;(BusinessListRef.value as any).getList()
            dataMap.dialogFormVisible = false
            ElMessage.success('操作成功！')
          }
        } catch (err:any) {
          console.log(222)
        }
      }
    })
    return { t, ...toRefs(dataMap), BusinessListRef }
  }
})
</script>
